import { Loader } from "components/Common/Loader";
import { getTransactionStatus } from "constants/apiUrls";
import { TransactionStatusEnum } from "enum/common";
import { http } from "middleware/apiMiddleware";
import React, { useEffect, useRef } from "react";
import { toast } from "react-hot-toast";
import { useNavigate, useSearchParams } from "react-router-dom";

const TransactionStatus: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const ref = useRef<any>(null);
  const countRef = useRef<number>(0);
  const businessId = searchParams.get("businessId");
  const planId = searchParams.get("planId");
  const navigate = useNavigate();
  const fetchPaymentStatus = async () => {
    try {
      const { error, data } = await http.get(
        getTransactionStatus(businessId || "", planId || "")
      );
      countRef.current += 1;
      if (
        data?.active === true &&
        data?.topupStatus === TransactionStatusEnum.SUCCESS
      ) {
        clearInterval(ref?.current);
        navigate("/");
      } else if (data?.topupStatus === TransactionStatusEnum.FAILED) {
        clearInterval(ref?.current);
        navigate("/");
        toast.error("Payment failed, you can retry activating the plan");
      } else if (
        countRef.current > 60 &&
        data?.topupStatus === TransactionStatusEnum.PENDING
      ) {
        clearInterval(ref?.current);
        navigate("/");
        toast.error("Payment failed, you can retry activating the plan");
      }
    } catch (error) {
      clearInterval(ref?.current);
      toast.error("Payment failed, you can retry activating the plan");
      navigate("/");
      console.error("payment status fetch failed");
    }
  };

  useEffect(() => {
    ref.current = setInterval(fetchPaymentStatus, 5 * 1000);
    return () => {
      if (ref.current) {
        clearInterval(ref.current);
      }
    };
  }, []);

  return (
    <div
      className={`bg-offWhite p-4 mx-auto md:w-[65vw]  flex-col flex gap-8 h-screen w-full justify-center items-center`}
    >
      <Loader label="Processing Payment" color="darkBlue" />
    </div>
  );
};

export default TransactionStatus;
